import { render, staticRenderFns } from "./dart-board.vue?vue&type=template&id=0626e802&scoped=true&"
import script from "./dart-board.vue?vue&type=script&lang=ts&"
export * from "./dart-board.vue?vue&type=script&lang=ts&"
import style0 from "./dart-board.vue?vue&type=style&index=0&id=0626e802&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626e802",
  null
  
)

export default component.exports